import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // One-time session exchange; guard against StrictMode double-run
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    (async () => {
      try {
        const res = await axios.post(
          `${BACKEND_URL}/api/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        navigate('/admin', { state: { user: res.data }, replace: true });
      } catch (err) {
        if (err.response?.status === 403) {
          toast.error('This Google account is not authorized for admin access.');
        } else {
          toast.error('Sign-in failed. Please try again.');
        }
        navigate('/', { replace: true });
      }
    })();
  }, [location, navigate]);

  // Process silently — no loading UI
  return null;
};

export default AuthCallback;
